<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        style="fill: currentColor"
    >
        <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.!-->
        <path
            d="M621.2 54.5C582.4 38.2 543.6 32 504.8 32c-123.2 0-246.3 62.3-369.5 62.3-30.9 0-61.8-3.9-92.7-13.7-3.5-1.1-7-1.6-10.4-1.6C15 79 0 92.3 0 110.8v317.3c0 12.6 7.2 24.6 18.8 29.5C57.6 473.8 96.5 480 135.3 480c123.2 0 246.3-62.4 369.5-62.4 30.9 0 61.8 3.9 92.7 13.7 3.5 1.1 7 1.6 10.4 1.6 17.2 0 32.3-13.3 32.3-31.8V83.9c0-12.6-7.2-24.6-18.9-29.5zM48 132.2c20.1 5 41.1 7.6 62.7 8.9C104.8 170.5 79 192.7 48 192.7v-60.5zm0 285v-47.8c34.4 0 62.2 27.3 63.7 61.4-22.5-1.8-43.6-6.3-63.7-13.6zM320 352c-44.2 0-80-43-80-96 0-53 35.8-96 80-96s80 43 80 96c0 53-35.8 96-80 96zm272 27.8c-17.5-4.4-35.7-6.9-54.3-8.4 5.9-26.1 27.5-45.9 54.3-49.3v57.7zm0-236.1c-30.9-3.9-54.9-29.7-55.8-61.6 19.5 2.2 38.1 6.2 55.8 12.7v48.9z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "fa-money-bill-wave",
});
</script>
